module.exports = __webpack_public_path__ + "media/images/icon-lock-1daf9c3cf11f6ff15c7d0174f7bb8ad9.svg";